import { columnType } from "./column-type.enum";

// These are separate section types, but the same name can mean different geometry, 
// because G-MBG for example can be in plinth and on the roof and while being on the roof makes it have different 3D shape and model

export const columnBays = [
    {
        type: columnType.C_S1S2,
        bays: 3,
        uiName: '2x S app.'
    },
    {
        type: columnType.C_M,
        bays: 2,
        uiName: 'M app.'
    },
    {
        type: columnType.C_L,
        bays: 3,
        uiName: 'L app.'
    },
    {
        type: columnType.C_XL,
        bays: 3,
        uiName: 'XL app.'
    },
    {
        type: columnType.C_XS,
        bays: 1,
        uiName: 'XS app.'
    }
]
